export const ExpressCheckoutAbTest = {
  TEST_ID: 'LixCqDh-QF-7qH7FKmJYDQ',
  name: 'Express Checkout AB Test - November 2021',
};

export const AccountCrossSellBannerCtaDestinationExperiment = {
  TEST_ID: '5l9j4H1vQpK1H_6veuHyqw',
  name: 'SK | Account Cross Sell Banner CTA Destination - June 2023',
};

export const CheckoutDesignOptimisation2Experiment = {
  TEST_ID: 'ZA8ZiAZCS0ibsN17ee7g1Q',
  name: 'Checkout Redesign #2 AB test - November 2023',
};

export const GrowthbookFakeExperimentExperiment = {
  TEST_ID: 'oHUXOZBgQHy7KCSh97Wjbg',
  name: 'GrowthBook Fake Experiment',
};
export const AccountUpsellExperiment = {
  TEST_ID: '',
  name: 'Upsell Account Launch AB test - September 2023',
};
